/* eslint-disable  @typescript-eslint/no-explicit-any */
import { Component, OnInit, Renderer2 } from '@angular/core';
import { ApiService } from '../api.service';
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { noWhitespaceInRequiredValidator } from '../shared/constants';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit {
	moduleForm: FormGroup = this.formBuilder.group({
		username: [null, [Validators.required, noWhitespaceInRequiredValidator]],
		password: [null, [Validators.required, noWhitespaceInRequiredValidator]]
	});
	formSubmitted = false;
	showLoader = false;
	displayError = false;
	errorMsg = "";
	data: any = null;
	step: number = 1;
	showQR = false;
	qrToShow: any;
	auth: any = { otp: null };
	qrStep = 1;

	constructor(private apiService: ApiService, private router: Router, private renderer: Renderer2, private toastr: ToastrService, private route: ActivatedRoute, private formBuilder: FormBuilder) { }

	ngOnInit(): void {
		if (localStorage.getItem("shore_token") != null && localStorage.getItem("shore_token") != undefined) {
			this.gotoDashboard();
		}
		// if (this.route.snapshot.queryParams['returnUrl'] && this.route.snapshot.queryParams['returnUrl'].indexOf("login") >= 0) {
		// 	this.router.navigate(["/login"]);
		// }
	}

	get f() { return this.moduleForm.controls; }

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}

	mfasession: any;
	login() {
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required parameters.", 'Warning', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		this.showLoader = true;
		this.apiService.loginAPI(this.moduleForm.value).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				if (data.mfasession) {
					this.mfasession = data.mfasession;
					this.step = 2;
					this.showQR = false;
					this.qrStep = 2;
				} else {
					this.data = data;
					this.proceedLogin();
				}
				/* this.data = data;
				this.proceedLogin(); */
			}, error: () => {
				this.showLoader = false;
				this.displayError = true;
				this.errorMsg = "Invalid credentials";
				setTimeout(() => {
					this.displayError = false;
					this.errorMsg = "";
				}, 4000)
			}
		});
	}

	next() {
		this.qrStep = 2;
	}

	verifyOTP() {
		if (!this.auth.otp) {
			this.toastr.warning("Please enter OTP", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		this.showLoader = true;
		let data: any = {
			username: this.f.username.value,
			password: this.f.password.value,
			session: this.mfasession,
			user_code: this.auth.otp
		};
		this.apiService.loginAPI(data).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				this.data = data;
				this.proceedLogin();
			}, error: (error: any) => {
				this.showLoader = false;
				this.displayError = true;
				this.errorMsg = "Invalid OTP";
				setTimeout(() => {
					this.displayError = false;
				}, 5000);
			}
		});
	}

	proceedLogin() {
		localStorage.setItem('shore_token', "Bearer " + this.data["token"]);
		localStorage.setItem('usertype', this.data["usertype"] || "SC");
		this.toastr.success("Logged in successfully", 'Success', {
			tapToDismiss: true,
			closeButton: true,
			timeOut: 3000
		});
		this.gotoDashboard();
	}

	gotoDashboard() {
		/* const returnUrl = this.route.snapshot.queryParams['returnUrl'] || this.apiService.getHomeURL();
		this.router.navigateByUrl(returnUrl); */
		this.router.navigate([this.apiService.getHomeURL()]);
	}

	gotoTermsAndCondition() {
		this.router.navigate(['/terms-conditions']);
	}
}
